import { useState } from 'react'
import { createFileRoute } from '@tanstack/react-router'

import { validateUserAddPermission } from '@/lib/api/auth'
import { Button } from '@/components/ui/button'
import {
  Credenza,
  CredenzaBody,
  CredenzaContent,
  CredenzaDescription,
  CredenzaHeader,
  CredenzaTitle,
} from '@/components/ui/credenza'
import DepartmentForm from '@/components/forms/department-form'
import { Icons } from '@/components/icons'

export const Route = createFileRoute(
  '/_home/user-role-management/department/add',
)({
  beforeLoad: async () => {
    validateUserAddPermission()
  },
  component: AddDepartmentPage,
})

export default function AddDepartmentPage() {
  const [showAddDepartmentPage, setShowAddDepartmentPage] = useState(false)
  return (
    <main className="space-y-4">
      <Button
        onClick={() => {
          setShowAddDepartmentPage(true)
        }}
      >
        <Icons.add className="size-4" />
        Add Department
      </Button>
      <Credenza
        open={showAddDepartmentPage}
        onOpenChange={setShowAddDepartmentPage}
      >
        <CredenzaContent className="w-full max-w-2xl justify-center">
          <CredenzaBody>
            <DepartmentForm
              setShowAddDepartmentPage={setShowAddDepartmentPage}
            />
          </CredenzaBody>
        </CredenzaContent>
      </Credenza>
    </main>
  )
}
